import { render, staticRenderFns } from "./ShowIncome.vue?vue&type=template&id=1ae32fe4&"
import script from "./ShowIncome.vue?vue&type=script&lang=js&"
export * from "./ShowIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports